import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import { PublicClientApplication } from "@azure/msal-browser";
import { BrowserRouter } from "react-router-dom";

// import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';
import { registerMsalIdentityEvents } from './utils/msalIdentity';

// Bootstrap components
//import 'bootstrap/dist/css/bootstrap.min.css';
//import 'bootstrap/dist/css/bootstrap.min.css';




const msalInstance = new PublicClientApplication(msalConfig);

registerMsalIdentityEvents(msalInstance);

const root = ReactDOM.createRoot(document.getElementById('root')!);

/**
 * We recommend wrapping most or all of your components in the MsalProvider component. It's best to render the MsalProvider as close to the root as possible.
 */
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <App instance={msalInstance} />
        </BrowserRouter>
    </React.StrictMode>
);